import { CLASS_NAMES, VARIANTS } from './constants';
import { useClasses } from '~/hooks';
import type { StringIndexedObject } from '~/types';
import type { PopoverMenuItemSize } from '~/components/PopoverMenu/types';
import type { IconProps } from '~/components/Icon/types';
import type { PopoverMenuItemSelectedColorVariant } from './types';

export interface PopoverMenuHook {
  classNames: StringIndexedObject<string>;
  iconProps: IconProps;
  arrowIconProps: IconProps;
  seperator?: boolean;
}

export default function usePopoverMenu(
  size: PopoverMenuItemSize,
  selected: boolean,
  selectedColor: PopoverMenuItemSelectedColorVariant,
): PopoverMenuHook {
  const classNames = useClasses(CLASS_NAMES, {
    variants: {
      size,
      selected: selected ? selectedColor : '',
      selectedColor: selected ? selectedColor : 'default',
    },
  });

  const { iconProps, arrowIconProps } = VARIANTS[size];

  return {
    classNames,
    iconProps,
    arrowIconProps,
  };
}
